// src/admin/components/OrderDetailsModal.js (Tam ve Güncel Kod)

import React, { useState } from 'react';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';
import ChangeStatusModal from './ChangeStatusModal';

const statusMap = {
    0: { text: 'Cancelled', bg: 'danger' },
    1: { text: 'Pending', bg: 'secondary' },
    2: { text: 'Send to Test', bg: 'info' },
    3: { text: 'Send to Print', bg: 'warning' },
    4: { text: 'Shipped', bg: 'success' },
};

function OrderDetailsModal({ show, onHide, group, onRefresh, apiBaseUrl }) {
    const [selectedOrderForStatusChange, setSelectedOrderForStatusChange] = useState(null);
    const [sendingToPrintId, setSendingToPrintId] = useState(null);

    if (!group) {
        return null;
    }

    const handleSendToPrint = async (orderToPrint) => {
        if (!window.confirm(`Are you sure you want to send order #${orderToPrint.order_id} to the printer?`)) {
            return;
        }
        setSendingToPrintId(orderToPrint.id);
        try {
            const formData = new URLSearchParams();
            formData.append('orderId', orderToPrint.id);
            await axios.post(`${apiBaseUrl}/index.php?action=sendToPrinter`, formData);
            alert('Order sent to printer successfully!');
            onRefresh();
        } catch (error) {
            console.error("Failed to send order to printer:", error);
            alert(`Error: ${error.response?.data?.error || 'Could not send order to printer.'}`);
        } finally {
            setSendingToPrintId(null);
        }
    };

    const DetailItem = ({ label, value }) => (
        <ListGroup.Item className="px-0 py-2">
            <Row>
                <Col xs={5} sm={4}><strong>{label}</strong></Col>
                <Col xs={7} sm={8} style={{ whiteSpace: 'pre-wrap' }}>{value || '-'}</Col>
            </Row>
        </ListGroup.Item>
    );

    return (
        <>
            <Modal show={show} onHide={onHide} size="lg" centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Details for Order Group #{group.baseOrderId}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {group.orders.map((order, index) => {
                        const statusInfo = statusMap[order.order_status] || { text: 'Unknown', bg: 'light' };
                        const isSending = sendingToPrintId === order.id;

                        return (
                            <div key={order.id} className={`p-3 rounded ${index > 0 ? "mt-4" : ""}`} style={{border: '1px solid #dee2e6'}}>
                                <Row className="mb-2">
                                    <Col>
                                        <h5 className="mb-0">{order.product_name}</h5>
                                        <Badge bg={statusInfo.bg} pill>{statusInfo.text}</Badge>
                                    </Col>
                                </Row>
                                <ListGroup variant="flush">
                                    {/* GÜNCELLENDİ: İstenen tüm yeni alanlar eklendi */}
                                    <DetailItem label="Order ID" value={order.order_id} />
                                    <DetailItem label="Character" value={order.book_character} />
                                    <DetailItem label="Parent Message" value={order.parent_message} />
                                    <DetailItem label="Price" value={`${order.price}£ + ${order.shipping_cost}£ (Shipping)`} />
                                    <DetailItem label="Quantity" value={order.quantity} />
                                    <DetailItem label="Parent Name" value={order.parent_name} />
                                    <DetailItem label="Phone Number" value={order.phone_number} />
                                    <DetailItem label="Mail Address" value={order.mail_adress} />
                                    <DetailItem label="Shipping Address" value={order.address} />
                                </ListGroup>
                                
                                {/* GÜNCELLENDİ: Aksiyon Butonları buraya taşındı */}
                                <div className="mt-3 d-flex gap-2 flex-wrap border-top pt-3">
                                    {String(order.order_status) === '2' && (
                                        <>
                                            <Button variant="success" size="sm" onClick={() => handleSendToPrint(order)} disabled={isSending}>
                                                {isSending ? <Spinner as="span" animation="border" size="sm" /> : 'Send to Print'}
                                            </Button>
                                            <Button variant="outline-secondary" size="sm" href={`https://littlehibba.com/inc/pdf/${order.order_id}_cover.pdf`} target="_blank">View Cover</Button>
                                            <Button variant="outline-secondary" size="sm" href={`https://littlehibba.com/inc/pdf/${order.order_id}_contents.pdf`} target="_blank">View Inner</Button>
                                        </>
                                    )}
                                    <Button variant="info" size="sm" onClick={() => setSelectedOrderForStatusChange(order)}>
                                        Manage Status
                                    </Button>
                                </div>
                            </div>
                        )
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {selectedOrderForStatusChange && (
                 <ChangeStatusModal 
                    show={!!selectedOrderForStatusChange}
                    orderId={selectedOrderForStatusChange.id}
                    currentStatus={selectedOrderForStatusChange.order_status}
                    onHide={() => setSelectedOrderForStatusChange(null)}
                    onSuccess={() => {
                        setSelectedOrderForStatusChange(null);
                        onRefresh();
                    }}
                    apiBaseUrl={apiBaseUrl}
                />
            )}
        </>
    );
}

export default OrderDetailsModal;